import posthog from 'posthog-js';

document.addEventListener('DOMContentLoaded', () => {
  const apiKey = document.querySelector('meta[name="posthog"]')?.getAttribute('content');

  if (apiKey)
    posthog.init(apiKey, {
      api_host: 'https://app.posthog.com',
      capture_pageview: 'history_change',
      autocapture: {
        event_allowlist: ['click', 'submit'], // DOM events from this list ['click', 'change', 'submit']
        element_allowlist: ['button', 'a', 'form', 'input'] // DOM elements from this list ['a', 'button', 'form', 'input', 'select', 'textarea', 'label']
      },
      disable_session_recording: true,
      disable_surveys: true,
      disable_surveys_automatic_display: true
    });
  else {
    // Dummy PostHog client
    posthog.init = function () {};
    posthog.identify = function (arg) { console.log(`PostHog identify: ${arg}`); };
    posthog.capture = function (event, data) { console.log(`PostHog capture - Event: ${event} - Data: ${JSON.stringify(data)}`); };
  }

  window.posthog = posthog;
});
